/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Sync_Space_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to sync space. Please try again." |
*
* @param {Spaces_Sync_Space_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_sync_space_error = /** @type {((inputs?: Spaces_Sync_Space_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Sync_Space_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Synchronisieren des Speicherplatzes. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Failed to sync space. Please try again.")
});